import styled from "styled-components"

export const Container = styled.div`
.map{
    width:270px;
    height:140px;
    border-radius:8px;
    margin-top:10px;
}
`